import {
  selectCurrentPlayer,
  selectCurrentPlayerCities,
  selectIsGameStarted,
  selectPhase,
  selectRound,
} from '../redux/reducers/sharedStateReducer/selectors';
import {checkIfMatchOver} from '../utils/gameState/checkIfMatchOver';
import {getCityHexKeys} from '../utils/gameState/getCityHexKeys';
import {
  selectIsParallelSupplyPhase,
  selectSupplyActingPlayer,
  selectSupplyActingPlayerCities,
} from '../utils/gameState/supply/parallelSupplySelectors';

/**
 * Ключ хода: чей ход, в какой фазе какого раунда. По его смене и понимается
 * «начался ход игрока».
 *
 * Этап фазы войны в ключ НЕ входит: этапы (найм, перемещение, маневр, стрельба)
 * идут внутри хода одного игрока, и на каждом из них ход не начинается заново.
 *
 * В одновременной фазе снабжения сетевой игры ход у всех сразу, а текущий
 * игрок — лишь якорь хода: ключ строится по игроку этого клиента, пока тот
 * раздает снабжение (selectSupplyActingPlayer), — анимация идет ему один раз
 * в начале фазы. Закончившему игроку и зрителю в этой фазе анимировать нечего.
 *
 * null означает «хода сейчас нет» — игра не идет либо уже закончилась.
 */
export const getTurnKey = (state) => {
  if (!selectIsGameStarted(state) || checkIfMatchOver(state)) {
    return null;
  }

  if (selectIsParallelSupplyPhase(state)) {
    const supplyPlayer = selectSupplyActingPlayer(state);
    return supplyPlayer ? `${selectRound(state)}|${selectPhase(state)}|${supplyPlayer.id}` : null;
  }

  const currentPlayer = selectCurrentPlayer(state);
  if (!currentPlayer) {
    return null;
  }

  return `${selectRound(state)}|${selectPhase(state)}|${currentPlayer.id}`;
};

/**
 * В начале хода игрока все его города разом заливаются его цветом — тем же
 * оверлеем, что показывает рост города при постройке
 * (HexGridRenderer.showCityGrowthAnimation): по нему сразу видно, чей ход и
 * чем этот игрок владеет.
 *
 * Доход ключевых точек здесь не показывается — это разметка хода, а не отчет о
 * прибавке, поэтому keyPoints пустые.
 */
export const playTurnStartCitiesAnimation = (state, hexGridRenderer) => {
  if (!hexGridRenderer) return;

  // Одновременная фаза снабжения — города игрока этого клиента (см. getTurnKey)
  const isParallelSupplyPhase = selectIsParallelSupplyPhase(state);
  const player = isParallelSupplyPhase ? selectSupplyActingPlayer(state) : selectCurrentPlayer(state);
  const cities = isParallelSupplyPhase ? selectSupplyActingPlayerCities(state) : selectCurrentPlayerCities(state);
  if (!player || !cities || cities.length === 0) return;

  const cityHexKeys = cities.flatMap((city) => [...getCityHexKeys(city)]);
  if (cityHexKeys.length === 0) return;

  hexGridRenderer.showCityGrowthAnimation({
    playerColor: player.color,
    cityHexKeys,
  });
};
